import { Vue } from 'vue-property-decorator';
import { IAdvisor } from './interfaces/advisor.interface';

export default class GlobalMixins extends Vue {
    advisors: IAdvisor[] = [];

    searchQuery: string = '';
    splitSearchQuery: any[] = [];
    resultsView: string = 'map';
    postalBase: any = '';
    minPostal: number = 0;
    maxPostal: number = 0;
    postalOffset: number = 500;
    
    filteredAdvisors: any[] = [];
    
    filterAdvisors() {
        // In case the searchQuery is not empty
        if (this.searchQuery != '') {

            let minLatitude: number
            let maxLatitude: number
            let minLongitude: number
            let maxLongitude: number
            // If you're searching for a postalCode, set some new variables:
            if (this.checkPostalCode() === true) {
                this.postalBase = parseFloat(this.splitSearchQuery.join(""));

                let x = this.postalBase;
                // Search for the closest corresponding PostalCode result.
                let closest = this.advisors
                    .filter((advisor) => advisor.billinglatitude && advisor.billinglongitude)
                    .sort(
                        (a: any, b: any) =>
                            Math.abs(x - parseFloat(a.billingpostalcode.split("").slice(0, 4).join(""))) -
                            Math.abs(x - parseFloat(b.billingpostalcode.split("").slice(0, 4).join("")))
                    )[0];

                const latLongOffset = 0.05;
                const closestLatitude = parseFloat(closest.billinglatitude);
                const closestLongitude = parseFloat(closest.billinglongitude);

                // Set range of results around your PostalCode
                minLatitude = closestLatitude - latLongOffset;
                maxLatitude = closestLatitude + latLongOffset;
                minLongitude = closestLongitude - latLongOffset;
                maxLongitude = closestLongitude + latLongOffset;
            }

            // Filter the advisors that correspond.
            return this.filteredAdvisors = this.advisors.filter(advisor => {
                // The search query can be the name of the city...
                // Or a range of results around your PostalCode...
                return  advisor.billingcity.toLowerCase().includes(this.searchQuery.toLowerCase())
                        || (parseFloat(advisor.billinglatitude) >= minLatitude && parseFloat(advisor.billinglatitude) <= maxLatitude) && (parseFloat(advisor.billinglongitude) >= minLongitude && parseFloat(advisor.billinglongitude) <= maxLongitude)
            })
        } else {
            return [];
        }
    }

    // Function to check if a postalcode is being searched
    checkPostalCode(): boolean {
        // Get the first four characters of your search
        this.splitSearchQuery = this.searchQuery.split('').slice(0, 4)

        // Expression to check if the value is not a number
        const isNotANumber = (currentValue: string) => isNaN(parseFloat(currentValue));

        // If none of the characters are a letter:
        if (!this.splitSearchQuery.some(isNotANumber)) {
            return true;
        } else {
            return false;
        }
    }
}